import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './style.css'
import './common.scss'
import App from './App.vue'
// import 'virtual:windi.css'

// import 'ant-design-vue/dist/reset.css';
const app = createApp(App)
app.use(ElementPlus)
app.mount('#app')

